import template from "./cost-modal-pricing.html";

const CostModalPricingComponent = {
  bindings: {
    close: "&",
    dismiss: "&",
    resolve: "<",
  },
  template: template,
  controller: class CostModalPricingController {
    /* @ngInject */
    constructor($rootScope, $q, $filter, ModalsManager, Cost, Notification) {
      this.$rootScope = $rootScope;
      this.$q = $q;
      this.$filter = $filter;
      this.ModalsManager = ModalsManager;
      this.Cost = Cost;
      this.NotificationService = Notification;
    }

    async $onInit() {
      this.editMode = this.resolve.editMode;
      this.openedCostLibrary = false;
      this.saveOnLibrary = false;
      this.searchText = "";
      this.costs = [];
      this.searchOptions = { name: "", page: 1 };

      this.cost = this.resolve.cost
        ? angular.copy(this.resolve.cost)
        : new this.Cost();
      this.saving = false;
      if (!this.cost.currency)
        this.setCurrency(this.$rootScope.organization.settings.currency);

      await this.refresh();
      this.$rootScope.$applyAsync();

      this.$rootScope.$watch(
        () => this.searchOptions.name,
        (newVal, oldVal) => {
          if (newVal !== oldVal) {
            if (newVal.length === 0) this.refresh().then();
            else this.findBySearchText().then();
            if (!this.openedCostLibrary) this.toggleOpenedCostLibrary();
          }
        }
      );
    }

    selectCost(cost) {
      this.close({ $value: cost });
    }

    cancel() {
      this.dismiss({ $value: "cancel" });
    }

    async findBySearchText() {
      this.loading = true;
      this.searchOptions.page = 1;
      const data = await this.$q
        .all({
          costPromise: this.Cost.query({
            q: this.searchOptions.name,
            page: this.searchOptions.page,
          }),
          costsCountPromise: this.Cost.getCount({ q: this.searchOptions.name }),
        })
        .then((values) => {
          return {
            costs: values.costPromise,
            costsCount: values.costsCountPromise,
          };
        });
      this.costs = data.costs;
      this.costsCount = data.costsCount;
      this.loading = false;
      this.$rootScope.$applyAsync();
    }

    async refresh() {
      this.searchOptions.name = "";
      await this.findBySearchText();
    }

    async loadMoreCosts() {
      const loadedCosts = this.costs.length;
      const costsToLoad = this.costsCount;
      if (loadedCosts < costsToLoad && !this.loading) {
        this.searchOptions.page++;
        const costs = await this.loadCosts();
        this.costs = this.costs.concat(costs);
        this.$rootScope.$applyAsync();
      }
    }

    async loadCosts() {
      this.loading = true;
      const costs = await this.Cost.query({
        q: this.searchOptions.name,
        page: this.searchOptions.page,
      });

      this.loading = false;
      this.$rootScope.$applyAsync();
      return costs;
    }

    setCurrency(oldCurrency, newCurrency) {
      this.cost.currency = newCurrency || oldCurrency;
    }

    toggleOpenedCostLibrary() {
      this.openedCostLibrary = !this.openedCostLibrary;
    }

    toggleSaveOnLibrary() {
      this.saveOnLibrary = !this.saveOnLibrary;
    }

    async save() {
      if (!this.form.$valid) return;
      if (this.saveOnLibrary) {
        this.saving = true;
        if (
          !(this.cost instanceof this.Cost) &&
          typeof this.cost.existsOnLibrary === "function" &&
          !this.cost.existsOnLibrary()
        ) {
          // Creacion del coste desde un cost snapshot
          const costSnapshot = this.cost;
          this.cost = new this.Cost();
          this.cost.setDataFromCostSnapshot(costSnapshot);
          await this.cost.create();
        } else if (
          typeof this.cost.existsOnLibrary === "function" &&
          this.cost.existsOnLibrary()
        ) {
          // Edición del coste desde un snapshot
          const costSnapshot = this.cost;
          this.cost = new this.Cost();
          this.cost.setDataFromCostSnapshot(costSnapshot);
          this.cost._id = costSnapshot.from;
          await this.cost.save();
        } else {
          // Edición del coste desde cero
          await this.cost.save();
        }
        this.saving = false;
        this.NotificationService.success({
          title: this.$filter("trans")("notificationService.title.success"),
          message: this.$filter("trans")(
            "notificationService.message.costSaved"
          ),
        });
      } else this.cost._id = null;
      this.close({ $value: this.cost });
      await this.refresh();
      this.$rootScope.$applyAsync();
    }
  },
};

export default CostModalPricingComponent;
